import { useEffect } from "react";

// Gestión manual de <title>/<meta description>/<link canonical> por página,
// sin depender de una librería (react-helmet) que no podíamos instalar/
// verificar en este entorno. Se sobreescribe en cada montaje — como solo
// hay una página montada a la vez en la SPA, no hace falta restaurar al
// desmontar.
const BASE_URL = "https://www.tualiadohostelero.com";

export function useDocumentHead({ title, description, path = "/" }) {
  useEffect(() => {
    if (title) document.title = title;

    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", "description");
        document.head.appendChild(meta);
      }
      meta.setAttribute("content", description);
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${BASE_URL}${path}`);
  }, [title, description, path]);
}
